import { useMutation } from "@tanstack/react-query";
import { message } from "antd";
import sdk, { GraphQLError } from "@/sdk";

export const useMonthlyFee = () => {
  const dispatchMutation = useMutation({
    mutationFn: (params: { year: number; month: number }) =>
      (sdk as any).dispatchMonthlyFees(params) as Promise<{
        dispatchMonthlyFees: { dispatched: number; batchId: string };
      }>,
    onSuccess: (data) => {
      const result = data.dispatchMonthlyFees;
      message.success(
        `Амжилттай илгээлээ: ${result.dispatched} даалгавар, Batch ID: ${result.batchId}`
      );
    },
    onError: (err) => {
      message.error(
        (err as GraphQLError).response?.errors?.[0]?.message ?? "Алдаа гарлаа"
      );
    },
  });

  const applyForUserMutation = useMutation({
    mutationFn: (params: { userId: string; year: number; month: number }) =>
      (sdk as any).applyMonthlyFeesForUser(params) as Promise<{
        applyMonthlyFeesForUser: {
          processedCount: number;
          totalFeeAmount: number;
          skippedCount: number;
          errors: Array<{ purchaseId: string; error: string }>;
        };
      }>,
    onSuccess: (data) => {
      const result = data.applyMonthlyFeesForUser;
      if (result.errors && result.errors.length > 0) {
        message.warning(
          `Дууслаа: ${result.processedCount} боловсруулсан, ${result.skippedCount} алгассан, ${result.errors.length} алдаа`
        );
      } else {
        message.success(
          `Амжилттай: ${result.processedCount} боловсруулсан, Нийт дүн: ${result.totalFeeAmount}₮`
        );
      }
    },
    onError: (err) => {
      message.error(
        (err as GraphQLError).response?.errors?.[0]?.message ?? "Алдаа гарлаа"
      );
    },
  });

  return {
    dispatchMutation,
    applyForUserMutation,
  };
};
